
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"36","viewBox":"0 0 100 62","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"y":".321","width":"99.753","height":"61.679","rx":"4","fill":"#ECC3FF"}}),_c('rect',{attrs:{"x":"5.332","y":"15.55","width":"26.651","height":"34.266","rx":"2.2","fill":"#7B01B5"}}),_c('path',{attrs:{"d":"M23.42 32.613a.5.5 0 010 .903l-8.045 3.825a.5.5 0 01-.715-.452v-7.65a.5.5 0 01.715-.451l8.044 3.825z","fill":"#fff"}}),_c('rect',{attrs:{"x":"36.551","y":"15.55","width":"26.651","height":"34.266","rx":"2.2","fill":"#7B01B5"}}),_c('path',{attrs:{"d":"M54.638 32.613a.5.5 0 010 .903l-8.044 3.825a.5.5 0 01-.715-.452v-7.65a.5.5 0 01.715-.451l8.044 3.825z","fill":"#fff"}}),_c('rect',{attrs:{"x":"67.77","y":"15.55","width":"26.651","height":"34.266","rx":"2.2","fill":"#7B01B5"}}),_c('path',{attrs:{"d":"M85.858 32.613a.5.5 0 010 .903l-8.044 3.825a.5.5 0 01-.715-.452v-7.65a.5.5 0 01.715-.451l8.044 3.825z","fill":"#fff"}}),_c('rect',{attrs:{"x":"5.332","y":"6.413","width":"39.596","height":"4.569","rx":"2.284","fill":"#B758E5"}}),_c('rect',{attrs:{"x":"5.332","y":"54.385","width":"71.578","height":"4.569","rx":"2.284","fill":"#B758E5"}})])
          )
        }
      }
    